import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import GoBack from "../components/GoBack";
import { DocumentCard } from "../components/common/DocumentCard";
import { PaymentAccountsCard } from "../components/financial/PaymentAccountsCard";

const Financial: React.FC = () => {
  const { id: applicationId } = useParams<{ id: string }>();
  const { t } = useTranslation();

  if (!applicationId) {
    return <p>{t("financial.missingApplicationId")}</p>;
  }

  return (
    <div className="mt-6">
      <GoBack />
      <PaymentAccountsCard applicationId={applicationId} />
      <DocumentCard
        applicationId={applicationId}
        documentType="bank-statement"
        titleKey="financial.bankStatements.title"
        inputLabelKey="financial.bankStatements.inputLabel"
        colFileNameKey="financial.bankStatements.colFileName"
        colActionsKey="financial.bankStatements.colActions"
        deleteLabelKey="financial.bankStatements.delete"
        confirmDeleteKey="financial.bankStatements.confirmDelete"
        errorFetchingKey="financial.bankStatements.errorFetching"
        errorDeletingKey="financial.bankStatements.errorDeleting"
        errorUploadingKey="financial.bankStatements.errorUploading"
      />
    </div>
  );
};

export default Financial;
